const SpotahomeGuaranteeIcon = props => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask id="path-1-inside-1_1437_4852" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 8L15 0.500002L0 0.5V8C0 9.98912 0.790176 11.8968 2.1967 13.3033C3.60322 14.7098 5.51088 15.5 7.5 15.5C9.48912 15.5 11.3968 14.7098 12.8033 13.3033C14.2098 11.8968 15 9.98913 15 8Z"
      />
    </mask>
    <path
      d="M15 0.500002L16.2375 0.500002V-0.737498L15 -0.737498V0.500002ZM15 8H13.7625V8L15 8ZM0 0.5L1.57356e-07 -0.7375L-1.2375 -0.7375V0.5H0ZM2.1967 13.3033L1.32165 14.1783L2.1967 13.3033ZM7.5 15.5L7.5 14.2625H7.5V15.5ZM12.8033 13.3033L11.9283 12.4283H11.9283L12.8033 13.3033ZM13.7625 0.500002L13.7625 8H16.2375L16.2375 0.500002L13.7625 0.500002ZM-1.57356e-07 1.7375L15 1.7375V-0.737498L1.57356e-07 -0.7375L-1.57356e-07 1.7375ZM1.2375 8V0.5H-1.2375V8H1.2375ZM3.07174 12.4283C1.8973 11.2538 1.2375 9.66092 1.2375 8H-1.2375C-1.2375 10.3173 -0.316944 12.5397 1.32165 14.1783L3.07174 12.4283ZM7.5 14.2625C5.83908 14.2625 4.24619 13.6027 3.07174 12.4283L1.32165 14.1783C2.96025 15.8169 5.18267 16.7375 7.5 16.7375V14.2625ZM11.9283 12.4283C10.7538 13.6027 9.16092 14.2625 7.5 14.2625L7.5 16.7375C9.81733 16.7375 12.0397 15.8169 13.6783 14.1783L11.9283 12.4283ZM13.7625 8C13.7625 9.66092 13.1027 11.2538 11.9283 12.4283L13.6783 14.1783C15.3169 12.5397 16.2375 10.3173 16.2375 8L13.7625 8Z"
      fill="#0D0D0D"
      mask="url(#path-1-inside-1_1437_4852)"
    />
    <path
      d="M4.77344 7.99967L6.59162 10.0451L11.5916 4.59058"
      stroke="#0D0D0D"
      strokeWidth="1.2375"
    />
  </svg>
);

export default SpotahomeGuaranteeIcon;
